import React, { useState, useRef, useEffect } from 'react'
import gsap from 'gsap'
import PropTypes from 'prop-types'

// Hooks
import { useScrolledAnimation } from '../../animation/useScrolledAnimation'

// Vars
import { Label } from '../../../styles/vars/textStyles.style'

// Styles
import {
  FormInputLabel,
  FormInputName,
  FormInputElement,
  FormInputLine,
} from './index.style'

const FormInput = ({
  name,
  id,
  type,
  required,
  forwardRef,
  formFields,
  setFormFields,
}) => {
  const [focused, setFocused] = useState(false)

  /**
   * If input fields have a value in them, move the label to be higher
   */
  const updateLabelPos = e => {
    if (e.target.value.length > 0) {
      setFocused(true)
    } else {
      setFocused(false)
    }
  }

  const updateInputValue = e => {
    setFormFields({
      ...formFields,
      [id]: e.target.value,
    })
  }

  const updateFunction = e => {
    updateLabelPos(e)
    updateInputValue(e)
  }

  const labelRef = useRef(),
    lineRef = useRef(),
    inputIn = useRef()

  useScrolledAnimation({
    id: `form-field-${id}`,
    transition: inputIn,
  })

  useEffect(() => {
    if (!labelRef.current || !lineRef.current) return

    inputIn.current = gsap.timeline({
      paused: true,
      defaults: {
        duration: 2,
        ease: 'power1.out',
      },
    })

    inputIn.current.fromTo(
      labelRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 0.4,
      },
      0
    )

    inputIn.current.fromTo(
      lineRef.current,
      {
        scaleX: 0,
      },
      {
        scaleX: 1,
      },
      0
    )
  }, [labelRef, lineRef])

  return (
    <FormInputLabel
      htmlFor={id}
      ref={forwardRef}
      data-scroll
      data-scroll-id={`form-field-${id}`}
    >
      <FormInputElement
        name={name}
        id={id}
        type={type}
        required={required}
        onChange={updateFunction}
      />
      <FormInputName focused={focused} ref={labelRef}>
        <Label>{name}</Label>
      </FormInputName>
      <FormInputLine ref={lineRef} />
    </FormInputLabel>
  )
}

FormInput.propTypes = {
  inView: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  forwardRef: PropTypes.object,
  delay: PropTypes.number,
}

export default FormInput
